import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetOpportunityDetails = function () {
    return useApiCall(function (signal, opportunityId) { return api.salesforce.apiSalesforceGetOpportunityDetailsGet(opportunityId, { signal: signal }); }, null, true, [], { success: 'Fetched opportunity details', error: 'Failed to fetch opportunity details' });
};
